

module dg.objects {

    export class ChildListController extends PropertyDisplayerControllerBase<dg.domain.IDomainObject[]> {

        public constructor(
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private actionService: dg.actions.ActionService
        ) {
            super();
        }


        public queryManipulator = new dg.actions.ClientQueryManipulator(this.$scope, this.$q, <any>{});
        public get compositeDisplayer(): dg.actions.ICompositeDisplayerOptions {
            return this.options;
        }

        init()   {
            let result = this.actionService.createChildQueryResult(this.value, this.propMeta);

            this.queryManipulator.setResult(result);

            this.queryManipulator.executeQuery();
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(ChildListController, 'childList', {
        templateUrl: '/digmo/src/objects/properties/child/child-list.html'
    });
}